import React, { Component } from 'react';
import './styles/Normalize.css';
import './Din.css';
import './styles/Typebase.css';
import './styles/App.css';

import { throttle } from 'lodash';


import Desktop from './components/Desktop';
import Mobile from './components/Mobile';

// STYLED

const delay = 200;

// COMPONENTE
class App extends Component {
	state = {
		data: [],
		width: window.innerWidth,
		height: window.innerHeight
	};

	componentDidMount() {
		window.addEventListener('resize', throttle(this.handleResize, delay));
	}

	handleResize = event => {
		this.setState({
			width: window.innerWidth,
			height: window.innerHeight
		});
	};

	render() {
		return (
			<div>
				{this.state.width <= 812 && <Mobile width={this.state.width} height={this.state.height} />}
				{this.state.width > 812 && <Desktop width={this.state.width} height={this.state.height} />}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js